import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { ensureSandboxOrRedirect } from '@/lib/utils/planner/ensureSandboxOrRedirect';

const paramsSchema = z.object({
  scenarioId: z.coerce.number().int().positive(),
});

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/planner/scenario/$scenarioId')({
  params: paramsSchema,
  beforeLoad: async ({ params: { loopId, org }, context: { queryClient } }) => {
    await ensureSandboxOrRedirect({ loopId, org, queryClient });
  },
});
